import React from 'react';
import { FormattedMessage } from 'react-intl';
import { takeEvery, put, call } from 'redux-saga/effects';
import { pushToast } from 'containers/ToastManager/actions';
import catchErrors from 'utils/commands/catchErrors';

import { commandIamTeamAccountSummary } from '../actions';
import messages from '../messages';
import * as constants from '../constants';

export function* sendRequest(connection, action) {
  const { teamId, accountId, accountIds, permissionLevel } = action;

  const iamTeamPermissionGrant = yield call(connection.fetch.bind(connection), {
    type: constants.RTM_IAM_TEAM_PERMISSION_GRANT,
    teamId,
    accountIds: accountIds || [accountId],
    permissionLevel,
  });

  if (iamTeamPermissionGrant.type === constants.RTM_IAM_TEAM_PERMISSION_GRANT_OK) {
    yield put(commandIamTeamAccountSummary(teamId));
  } else {
    yield put(pushToast({
      type: 'simple',
      message: iamTeamPermissionGrant.message || <FormattedMessage {...messages.permissionGrantError} />,
    }));
  }
}

export default function* (connection) {
  yield takeEvery(constants.COMMAND_GRANT_PERMISSION_ON_TEAM, catchErrors, sendRequest, connection);
}
